export default __webpack_public_path__ + "images/intakec15e5aa63db524f3f594b00e95ad5024.svg";